var map = {
	"./bsc/ADA.svg": "2234",
	"./bsc/BJT.svg": "2010",
	"./bsc/BNB.svg": "a889",
	"./bsc/BTC.svg": "85ca",
	"./bsc/BUSD.svg": "f7d1",
	"./bsc/DOGE.svg": "a9fe",
	"./bsc/ETH.svg": "87c5",
	"./bsc/GAL.svg": "a66b",
	"./bsc/HOGE.svg": "5ae4",
	"./bsc/PAD.svg": "04c3",
	"./bsc/PR.svg": "890b",
	"./bsc/PXBSC.svg": "8b00",
	"./bsc/TOAD.svg": "d61c",
	"./bsc/USDC.svg": "cd99",
	"./bsc/USDT.svg": "8d40",
	"./moonbeam/AVAX.svg": "54b9",
	"./moonbeam/BTC.svg": "cb81",
	"./moonbeam/PAD.svg": "f80b",
	"./moonbeam/TOAD.svg": "f4b3",
	"./moonbeam/USDT.svg": "f058",
	"./moonbeam/anyBNB.svg": "b2e3",
	"./moonbeam/anyBUSD.svg": "fde7",
	"./moonbeam/anyETH.svg": "20f8",
	"./moonbeam/anyUSDC.svg": "9171",
	"./moonbeam/xETH.svg": "d6ba",
	"./moonbeam/xUSDC.svg": "b0e1",
	"./moonbeam/xUSDT.svg": "1e1e",
	"./moonriver/BNB.svg": "6c4b",
	"./moonriver/BUSD.svg": "1591",
	"./moonriver/ETH.svg": "32b0",
	"./moonriver/FRAX.svg": "581f",
	"./moonriver/MRBTC.svg": "c7fa",
	"./moonriver/PAD.svg": "16b8",
	"./moonriver/ROME.svg": "441d",
	"./moonriver/TOAD.svg": "7ed6",
	"./moonriver/USDC.svg": "6133",
	"./moonriver/USDT.svg": "60a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb8e";